import { createBrowserRouter, RouteObject } from 'react-router-dom';

import { QueryClient } from '@tanstack/react-query';

import { coerceBoolean, isDefined, isEmpty } from '@hsp/utilities';

import { App } from 'components/app';
import { RedirectToDashboard } from 'components/redirects/dashboard';
import { RedirectToError } from 'components/redirects/error';
import { RedirectTo404 } from 'components/redirects/not-found';
import { paths } from 'constants/paths';
import { routes } from 'routes';
import { Route } from 'types/routes';
import { convertPathKey } from 'utilities/strings';

const createRoute = (config: Route, queryClient: QueryClient) => {
  const { action, children, element, handle, index, loader, path } = config;
  const route: RouteObject = {
    action: isDefined(action) ? action(queryClient) : undefined,
    element,
    handle,
    index: coerceBoolean(index, false),
    loader: isDefined(loader) ? loader(queryClient) : undefined,
    path: isDefined(path) ? convertPathKey(path) : undefined,
  };

  if (isDefined(children) && !isEmpty(children)) {
    route.children = children.map((child) => createRoute(child, queryClient));
  }

  return route;
};

export const useCreateRouter = (queryClient: QueryClient) => {
  const { nonAuthLayout, verticalLayout } = routes;
  const children: RouteObject[] = [
    {
      element: <RedirectToDashboard />,
      index: true,
    },
    createRoute(nonAuthLayout, queryClient),
    createRoute(verticalLayout, queryClient),
    {
      element: <RedirectTo404 />,
      path: '*',
    },
  ];

  const siteRoutes: RouteObject[] = [
    {
      children,
      element: <App />,
      errorElement: <RedirectToError />,
      path: paths.Root.path,
    },
  ];

  return createBrowserRouter(siteRoutes);
};
